var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.narocilo !== null && typeof _vm.narocilo[_vm.atribut] !== 'undefined')?_c('div',{style:(_vm.dodatenStil)},[(_vm.atributNaziv.length > 0)?_c('span',[_vm._v("\n    "+_vm._s(_vm.atributNaziv)+":\n  ")]):_vm._e(),_vm._v(" "),_c('span',[_c('b',[_vm._v("\n      "+_vm._s(_vm.narocilo[_vm.atribut])+"\n    ")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3ac3600","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Mojprofil/T2klub/MojaNarocilaInfo/MojaNarocilaAtribut.vue
// module id = dCuh
// module chunks = 3